import { z } from "zod/v4";

import { AgencyDtoSchema } from "../../../dtos/agencies";

export const GetAllAgenciesRequestBodySchema = z.object({
  agencies: AgencyDtoSchema.array(),
});

export type GetAllAgenciesResponseBodyType = z.infer<
  typeof GetAllAgenciesRequestBodySchema
>;
